import { alternatePath } from "./routing";
import { getLocale, locales } from "../data/locales";
import type { Locale } from "../types";

const defaultSiteUrl = "https://textpolish-tools.pages.dev";

export function applyPageSeo(options: {
  title: string;
  description: string;
  locale: Locale;
  path: string;
  siteUrl?: string;
}) {
  const siteUrl = options.siteUrl || defaultSiteUrl;
  const localeConfig = getLocale(options.locale);
  document.documentElement.lang = localeConfig.hreflang;
  document.documentElement.dir = localeConfig.dir;
  document.title = options.title;
  setMeta("description", options.description);
  setCanonical(`${siteUrl}${options.path}`);
  locales.forEach((locale) => {
    setAlternate(locale.hreflang, `${siteUrl}${alternatePath(options.path, locale.id)}`);
  });
  setAlternate("x-default", `${siteUrl}${alternatePath(options.path, "en")}`);
}

function setMeta(name: string, content: string) {
  let element = document.querySelector(`meta[name="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function setCanonical(href: string) {
  let element = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.href = href;
}

function setAlternate(hreflang: string, href: string) {
  let element = document.querySelector<HTMLLinkElement>(`link[rel="alternate"][hreflang="${hreflang}"]`);

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "alternate");
    element.setAttribute("hreflang", hreflang);
    document.head.appendChild(element);
  }

  element.href = href;
}
